import { render, staticRenderFns } from "./ActionEffect.vue?vue&type=template&id=2bb78586&"
import script from "./ActionEffect.vue?vue&type=script&lang=ts&"
export * from "./ActionEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports